// extracted by mini-css-extract-plugin
export default {"chart":"G_cR"};